import { BookingService } from './../../booking/models/booking.service';
import { FlatPickrDirective } from './../../plugins/flatpickr/flatpickr.directive';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import { TripDetilReportService } from './../models/tripdetailreport.service';
import { TripDetailReportModel } from './../models/tripdetailreport.model';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { WeGoConfig, IAPIResponse, ApplicationRouteURL, DataListModel } from '../../shared/config';

const moment = require("moment");

@Component({
  selector: 'wego-tripdetail-report',
  template: require('../views/tripdetailreport.component.html'),
  providers: [TripDetilReportService, BookingService],
  styles: [`
          .box-body{
            padding: 0px 10px 10px;
          }
          .checkbox-inline{
            padding-left: 0px !important;
          }
          .box-body{
            padding:10px 10px 10px 10px;
          }
          .search
          {
            margin-top:5px;
          }
          `
  ]
})
export class TripDetailReportComponent implements OnInit {

  @ViewChild('flatPickrConfigFromDate') public flatPickrConfigFromDate: FlatPickrDirective;
  @ViewChild('flatPickrConfigToDate') public flatPickrConfigToDate: FlatPickrDirective;

  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  DataListModel: DataListModel;
  tripDetailList: TripDetailReportModel[];
  model: TripDetailReportModel;
  instanceHashId: string;
  message: string;
  apiErrorMsg: string;
  isLoading: boolean;
  urlDefaultPage: string;
  deleteMessage: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  errorModel: any;
  isInit: boolean = true;
  driverVehicleList: any;
  public listOfFilterRecord: any[];
  itemPerPageList: any;


  private popupMsg: string;
  private module: string;
  private breadCrumbList: string;

  constructor(private tripdetailreportservice: TripDetilReportService,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router) {
  }

  ngOnInit() {
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.module = this.translate.instant('LblTripDetailReport');
    this.ResetPaging();
    this.model = new TripDetailReportModel();
    //this.model.startDateTime = moment().format('DD-MM-YYYY HH:mm');
    //this.model.endDateTime = moment().add(+1, 'M').format('DD-MM-YYYY HH:mm');
    this.model.startDateTime = moment().add(-2, 'M').format('DD-MM-YYYY HH:mm');
    this.model.endDateTime =  moment().format('DD-MM-YYYY HH:mm');

    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo.defaultDate = "23:59";
    
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public OnFromDateChange(value: string) {
    console.log(value);
    this.ResetPaging();
    console.log(this.model.endDateTime);
    if (value) {
      let format = 'DD-MM-YYYY HH:mm';
      let newDate = moment(value, format).toDate();
      let endDate = moment(this.model.endDateTime, format).toDate();
      if (endDate < newDate) {
        let endDateVal = moment(value, format).add('H', 1);
        this.flatPickrConfigToDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm'));
      }
      this.flatPickrConfigToDate.SetOption("minDate", newDate);
    }
  }

  public OnToDateChange($event: any) {
    this.ResetPaging();
  }

  public OnVehicleChange($event: any) {
    this.ResetPaging();
  }

  private SuccessSelectDriverModal($event: any) {
    this.model.driverHashId = $event.DriverHashID;
    this.model.filterDriverName = $event.DriverName;
    this.model.vehicleHashId = '';
    this.GetDriverVehicleList(this.model.driverHashId);
    this.ResetPaging();
  }

  private OnSearchTrips() {
    console.log(this.model);
    this.ResetPaging();
    this.GetDriverTripDetail();
  }

  private GetDriverTripDetail() {
    this.isLoading = true;
    this.tripdetailreportservice.GetDriverTripDetailList(this.model)
      .subscribe(
      (res: any) => {
        if (!res.data) {
          this.errorModel = res.error;
          this.isLoading = false;
        }
        else {
          this.errorModel = null;
          this.tripDetailList = res.data;
          this.DataListModel.totalItems = res.data.length;
          this.DataListModel.infoMessage = res.error;
          this.FilterList();
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.tripDetailList = [];
      });
  }

  private GetDriverVehicleList(driverHashId: string) {
    this.isLoading = true;
    this.tripdetailreportservice.GetDriverVehicleList(driverHashId)
      .subscribe(
      (res: any) => {
        if (!res.data) {
          this.errorModel = res.error;
          this.isLoading = false;
        }
        else {
          this.errorModel = null;
          this.driverVehicleList = res.data;
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.itemsPerPage = event;
    this.FilterList();
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.FilterList();
  }

  public FilterList() {
    let start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
    let end = start + (this.DataListModel.itemsPerPage);
    this.listOfFilterRecord = this.tripDetailList.slice(start, end);
  }

  public ResetPaging() {
    this.tripDetailList = [];
    this.listOfFilterRecord = [];
    this.DataListModel = new DataListModel();
    this.DataListModel.itemsPerPage = 10;
  }

  public OnExport(event: any) {
    this.isLoading = true;
    this.tripdetailreportservice.ExportTripDetailReport(this.model)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "TripDetailReport" + new Date().toISOString() + ".csv";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }

  public OnExportPdf(event: any) {
    this.isLoading = true;
    this.tripdetailreportservice.ExportTripDetailReportPDF(this.model)
      .subscribe(
      (res: any) => {
        if (res && res._body) {
          let fileName = "TripDetailReport" + new Date().toISOString() + ".pdf";
          this.authService.DownloadFile(fileName, res._body);
        }
        this.isLoading = false;
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      });
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/tripdetailreport/components/tripdetailreport.components.ts